import {Component} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {GesellschaftZusatzangaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-atypische-stille-beteiligung-angaben',
  templateUrl: './atypische-stille-beteiligung-angaben.component.html'
})
export class AtypischeStilleBeteiligungAngabenComponent extends FormBaseComponent<GesellschaftZusatzangaben> {

  constructor(private readonly formBuilder: FormBuilder,
              protected readonly messageService: DatevMessageService,
              protected readonly activatedRoute: ActivatedRoute) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      isAtypisch: [this.data?.isAtypisch, []]
    });
  }

}
